import { render } from "./IconPlus.vue?vue&type=template&id=0e111000"
import script from "./IconPlus.vue?vue&type=script&lang=js"
export * from "./IconPlus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__